let audio = null;
let unlocked = false;
let isPlaying = false;

export function initSoundUnlock(src = 'https://client.salesmartly.com/setting/sounds/ling.mp3') {
  if (unlocked) return;

  audio = new Audio(src);
  audio.preload = 'auto';

  document.addEventListener('click', () => {
    audio.play().then(() => {
      audio.pause();
      audio.currentTime = 0;
      unlocked = true;
    }).catch(err => {
      console.warn('音频解锁失败:', err);
    });
  }, { once: true });

  // 播放完后重置状态
  audio.addEventListener('ended', () => {
    isPlaying = false;
  });
}

/**
 * 播放提示音
 */
export function playNotificationSound() {
  if (!unlocked || !audio) return;
  if (isPlaying) return;

  isPlaying = true;
  audio.currentTime = 0;
  audio.play().catch(err => {
    console.warn('播放音频失败:', err);
    isPlaying = false;
  });
}
